// Interview Get User Info ************************************************************************
// pathname: /v1/interview/user-info
// ************************************************************************************************
import {
  ApiUserSubscriptionInfoOk,
  ApiUserSubscriptionList, ApiUserSubscriptionOrder, ApiUserSubscriptionOrderOk,
  ApiUserSubscriptionPaymentDetails, ApiUserSubscriptionPaymentDetailsOk,
} from '@type/v1-api-types/user-subscription';

// User Subscription info *************************************************************************
// pathname: /v1/user-subscription/list
// ************************************************************************************************
export const isApiUserSubscriptionListOk = (res: ApiUserSubscriptionList | void)
: res is ApiUserSubscriptionInfoOk => res !== undefined && res !== null && (res as ApiUserSubscriptionInfoOk)?.length > 0;

// User Subscription payment details info *********************************************************
// pathname: /v1/user-subscription/payment-details
// ************************************************************************************************
export const isPaymentDetailsStatusOk = (res: ApiUserSubscriptionPaymentDetails | void): res is ApiUserSubscriptionPaymentDetailsOk => res !== undefined
    && res !== null;

// User Subscription order info *******************************************************************
// pathname: /v1/user-subscription/order
// ************************************************************************************************
export const isUserSubscriptionOrderOk = (res: ApiUserSubscriptionOrder | void): res is ApiUserSubscriptionOrderOk => res !== undefined
    && res !== null && Object.keys(res).length > 0;
